import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme) =>
  createStyles({
    root: {
      margin: '20px 0',
    },
  });

export type Styles = WithStyles<typeof styles>;
